import React from 'react';

interface PlayingCardProps {
  value: string;
  suit?: string;
  size?: 'sm' | 'md' | 'lg';
}

const SUIT_SYMBOLS: Record<string, string> = {
  h: '♥', d: '♦', s: '♠', c: '♣',
  '♥': '♥', '♦': '♦', '♠': '♠', '♣': '♣',
};

const RED_SUITS = new Set(['h', 'd', '♥', '♦']);

const SIZE_MAP = {
  sm: { width: 28, height: 36, fontSize: 13, suitSize: 10 },
  md: { width: 36, height: 48, fontSize: 18, suitSize: 13 },
  lg: { width: 48, height: 64, fontSize: 24, suitSize: 16 },
};

/** Accepts either "Ah" (value+suit joined) or value="A" suit="h" separately */
export default function PlayingCard({ value, suit, size = 'sm' }: PlayingCardProps) {
  let cardValue = value;
  let cardSuit = suit ?? '';

  // Handle combined format like "Ah", "Kd", "10s"
  if (!suit && value.length >= 2) {
    cardSuit = value.slice(-1).toLowerCase();
    cardValue = value.slice(0, -1);
  }

  const suitSymbol = SUIT_SYMBOLS[cardSuit] ?? cardSuit;
  const isRed = RED_SUITS.has(cardSuit);
  const dim = SIZE_MAP[size];

  return (
    <div
      style={{
        width: dim.width,
        height: dim.height,
        background: '#1e1e1e',
        border: '1px solid #333',
        borderRadius: 4,
        display: 'inline-flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1,
        flexShrink: 0,
        boxShadow: '0 2px 6px rgba(0,0,0,0.4)',
      }}
    >
      <span
        style={{
          fontSize: dim.fontSize,
          fontWeight: 700,
          color: isRed ? '#e53935' : '#ffffff',
          lineHeight: 1,
          fontFamily: 'Inter, sans-serif',
        }}
      >
        {cardValue}
      </span>
      <span
        style={{
          fontSize: dim.suitSize,
          color: isRed ? '#e53935' : '#ffffff',
          lineHeight: 1,
        }}
      >
        {suitSymbol}
      </span>
    </div>
  );
}
